import { SparseSpectrumGenerator } from "./SparseSpectrumGenerator.js";
/**
 * Generates a sparse spectrum containing only x values where at least one peak
 * contributes above the threshold. Unlike `generateSpectrum`, no dense array
 * is allocated: intervals are computed per peak first, then y is evaluated only
 * for the merged set of required x values.
 * @param peaks - List of peaks to include.
 * @param options - Configuration for sparse spectrum generation.
 * @returns Sparse spectrum data with x and y arrays covering only peak regions.
 */
export function generateSparseSpectrum(peaks, options = {}) {
    const { generator, ...rest } = options;
    return new SparseSpectrumGenerator(generator).generateSparseSpectrum(peaks, rest);
}
//# sourceMappingURL=generateSparseSpectrum.js.map